export default {
  token: "token",
  userInfo: "userInfo",
  isLoggedin :"isLoggedin",
  language : "language",
  categories : "categories",
  role : "role",
};
